import { render, staticRenderFns } from "./RegisterAdditionalModal.vue?vue&type=template&id=298cb33d&"
import script from "./RegisterAdditionalModal.vue?vue&type=script&lang=ts&"
export * from "./RegisterAdditionalModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports